<template>
  <v-card>
    <v-card-title>
      <div class="heading">Курс {{ course.name }}</div>
    </v-card-title>
    <v-card-text>
      <v-col lg12>
        <v-form ref="courseForm" name="courseForm">
          <FileInput
            @file-selected="imageSelected"
            :field-name="'cover'"
            :url="course.cover.url"
          ></FileInput>
          <v-col lg12>
            <v-text-field
              v-model="course.name"
              :rules="rules.required"
              label="Название"
              name="name"
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col>
            <v-row row>
              <v-col lg6>
                <v-menu
                  ref="dateMenu"
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="date"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="date"
                      prepend-icon="event"
                      readonly
                      :rules="rules.required"
                      v-on="on"
                      outlined
                    >
                      <template v-slot:label>
                        <span>{{ dateLabel }}</span>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker v-model="date" locale="ru-ru" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="dateMenu = false">Закрыть</v-btn>
                    <v-btn text color="primary" @click="$refs.dateMenu.save(date)"> Выбрать </v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col lg6>
                <v-menu
                  ref="timeMenu"
                  v-model="timeMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="time"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="time"
                      prepend-icon="mdi-timelapse"
                      readonly
                      :rules="rules.required"
                      label="Время начала"
                      v-on="on"
                      outlined
                    >
                    </v-text-field>
                  </template>
                  <v-time-picker v-model="time" locale="ru-ru" scrollable format="24hr">
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="timeMenu = false">Закрыть</v-btn>
                    <v-btn text color="primary" @click="$refs.timeMenu.save(time)"> Выбрать </v-btn>
                  </v-time-picker>
                </v-menu>
                <input hidden v-model="courseStartDate" name="start_date" />
              </v-col>
              <v-col lg3>
                <v-switch
                  v-model="course.published"
                  color="green"
                  name="published"
                  :label="course.published ? 'опубликован' : 'не опубликован'"
                ></v-switch>
              </v-col>
              <v-col lg3>
                <v-switch
                  v-model="course.is_public"
                  color="green"
                  name="is_public"
                  :label="course.is_public ? 'публичный' : 'приватный'"
                ></v-switch>
              </v-col>
            </v-row>
          </v-col>
          <v-col>
            <v-textarea
              v-model="course.description"
              :rules="rules.required"
              label="Краткое описание"
              name="description"
              outlined
            >
            </v-textarea>
          </v-col>
          <v-col>
            <v-card-title>Блок "Для кого"</v-card-title>
            <ckeditor
              :editor="ckeditor"
              v-model="course.for_whom"
              :config="ckConfig"
              type="classic"
              required
              :upload-adapter="UploadAdapter"
            >
            </ckeditor>
            <input
              hidden
              name="for_whom"
              v-model="course.for_whom"
              :rules="rules.required"
              label='контент блока "Для кого"'
            />
          </v-col>
          <v-col>
            <v-card-title>Блок "Что вы узнаете"</v-card-title>
            <ckeditor
              :editor="ckeditor"
              v-model="course.what_will_learn"
              :config="ckConfig"
              type="classic"
              required
              :upload-adapter="UploadAdapter"
            >
            </ckeditor>
            <input
              hidden
              name="what_will_learn"
              v-model="course.what_will_learn"
              :rules="rules.required"
              label='контент блока "Чему научитесь"'
            />
          </v-col>
          <v-col v-if="isEdit">
            <v-card elevation="0">
              <v-toolbar dark flat color="green">
                <v-toolbar-title>Лекции</v-toolbar-title>
              </v-toolbar>
              <v-list>
                <v-list-item v-for="item in lectures" :key="item.id" @click="editLecture(item.id)">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.name"></v-list-item-title>
                    <v-list-item-subtitle
                      >{{ $moment(item.start_date).format('LL') }}
                      {{ $moment.duration(item.duration, 'minutes') }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                  <v-list-item-action-text>
                    <v-btn icon big color="error" @click.stop="removeLecture(item.id)">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-list-item-action-text>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-dialog
                      fullscreen
                      hide-overlay
                      transition="dialog-bottom-transition"
                      v-model="lectureDialog"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="text-center"
                          dark
                          outlined
                          color="green"
                          v-bind="attrs"
                          v-on="on"
                        >
                          добавить лекцию
                        </v-btn>
                      </template>
                      <Lecture
                        :courseId="course.id"
                        @lecture-update="lectureUpdate"
                        @cancel="lectureDialog = false"
                      ></Lecture>
                    </v-dialog>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>

            <v-card elevation="0">
              <v-toolbar dark flat color="orange">
                <v-toolbar-title>Экзамен</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <Poll :id="$route.params.id" :type="pollType"></Poll>
              </v-card-text>
            </v-card>

            <v-card elevation="0">
              <v-toolbar dark flat color="teal">
                <v-toolbar-title>Заявки</v-toolbar-title>
              </v-toolbar>
              <v-list>
                <v-list-item v-for="item in subscribes" :key="item.id">
                  <v-list-item-content>
                    <v-list-item-title v-text="item.listener.user.name"></v-list-item-title>
                    <v-list-item-subtitle>{{ statusMap[item.status] }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action-text>
                    <v-btn icon big color="error">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-list-item-action-text>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
          <v-row>
            <v-col lg6>
              <v-btn color="green" dark @click="save">Сохранить</v-btn>
            </v-col>
          </v-row>
        </v-form>
        <v-dialog
          fullscreen
          max-width="600px"
          hide-overlay
          transition="dialog-bottom-transition"
          v-model="editLectureDialog"
        >
          <Lecture
            :courseId="course.id"
            :lecture-id="editLectureId"
            @lecture-update="lectureUpdate"
            @cancel="editLectureDialog = false"
          ></Lecture>
        </v-dialog>
      </v-col>
    </v-card-text>
  </v-card>
</template>

<script>
import FileInput from '@/components/FileInput'
import ckeditorMixin from '@/mixins/ckeditor'
import firmMixins from '@/mixins/forms'
import Lecture from '@/components/hps/Lecture'
import Poll from '@/components/polls/Poll'
import * as pollAPI from '@/api/polls'

export default {
  name: 'Course',
  components: { Lecture, FileInput, Poll },
  mixins: [ckeditorMixin, firmMixins],
  props: {
    courseId: { type: String, required: false, default: '' },
  },
  data() {
    return {
      lectureDialog: false,
      time: '',
      date: '',
      dateMenu: false,
      timeMenu: false,
      editLectureDialog: false,
      editLectureId: 0,
      pollType: pollAPI.POLL_OBJECTS.HPS_COURSE,
      course: {
        name: '',
        description: '',
        teacher_id: '',
        what_will_learn: '',
        for_whom: '',
        start_date: '',
        start_time: '',
        cover: { url: '' },
        cover_id: '',
        published: false,
        is_public: false,
        lectures: [],
        subscribes: [],
        poll: {
          name: '',
          questions: [],
        },
      },
      statusMap: {
        1: 'Новая',
        2: 'Одобрена',
        3: 'Отклонено',
      },
    }
  },
  computed: {
    lectures() {
      return this.course.lectures
    },
    subscribes() {
      return this.course.subscribes
    },
    isEdit() {
      return !!this.course.id || !!this.courseId
    },
    dateLabel() {
      const x = this.$moment(this.course.start_date)
      if (!x.isValid()) {
        return 'Выберите дату'
      }
      return x.format('LL')
    },
    courseStartDate() {
      return this.$moment(`${this.date}T${this.time}`).format()
    },
  },
  watch: {
    courseId() {
      this.course.id = this.courseId
      this.getCourseData()
    },
  },
  mounted() {
    if (this.isEdit) {
      this.getCourseData()
      this.getCourseSubscribes()
    }
  },
  methods: {
    removeLecture(id) {
      this.axios({
        url: `/v1/hps/lectures/${id}`,
        method: 'delete',
      })
        .then((resp) => {
          this.$emit('lecture-delete')
          this.getCourseData()
        })
        .catch((err) => {
          this.$log.error('get course', err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    editLecture(id) {
      this.editLectureId = id
      this.editLectureDialog = true
    },
    lectureUpdate(id) {
      this.lectureDialog = false
      this.getCourseData()
    },
    teacherSelected(id) {
      this.course.teacher_id = id
    },
    imageSelected(e) {
      this.course.image = e
    },
    getCourseSubscribes() {
      this.axios({
        url: `/v1/hps/courses/${this.$route.params.id}/subscribe`,
        method: 'get',
      })
        .then((resp) => {
          // this.course.subscribes = resp.data
          this.$set(this.course, 'subscribes', resp.data)
        })
        .catch((err) => {
          this.$log.error('get course subscribes', err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    getCourseData() {
      this.axios({
        url: `/v1/hps/courses/${this.$route.params.id}`,
        method: 'get',
      })
        .then((resp) => {
          this.course = resp.data
          this.time = this.$moment(this.course.start_date).format('HH:mm')
          this.date = this.$moment(this.course.start_date).format('YYYY-MM-DD')
        })
        .catch((err) => {
          this.$log.error('get course', err)
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    updateCourse() {
      const d = new FormData(this.$refs.courseForm.$el)
      d.set('published', this.course.published ? 1 : 0)
      d.set('is_public', this.course.is_public ? 1 : 0)
      this.axios({
        url: `/v1/hps/courses/${this.course.id}`,
        method: 'post',
        data: d,
        config: { headers: { 'content-type': 'multipart/form-data' } },
      })
        .then((resp) => {
          this.course = resp.data
          this.$set(this.course, 'lectures', resp.data.lectures)
          this.$emit('course-update', this.course)
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.showSnackbar(err.response ? err.response.data : err, 'error')
        })
    },
    save() {
      if (this.isEdit) {
        this.updateCourse()
        return
      }
      if (!this.$refs.courseForm.validate()) {
        this.showSnackbar('Исправьте ошибки', 'error')
        return
      }
      const d = new FormData(this.$refs.courseForm.$el)
      d.set('published', this.course.published ? 1 : 0)
      d.set('is_public', this.course.is_public ? 1 : 0)
      this.axios({
        url: '/v1/hps/courses',
        method: 'post',
        data: d,
        config: { headers: { 'content-type': 'multipart/form-data' } },
      })
        .then((resp) => {
          this.course = resp.data
          this.$emit('course-update', this.course)
          this.showSnackbar('Сохранено', 'green')
        })
        .catch((err) => {
          this.showSnackbar(err.response.data, 'error')
        })
    },
  },
}
</script>
